export const COURSE_TEMPLATE_LIBRARY_GUIDE_FLAG = 'FEON-95-course-template-library-guide'

export const COURSE_TEMPLATE_LIBRARY_DEEPLINK_QUERY = Object.freeze({
  open: 'course-template-library',
  deepLinkSource: 'in-app-guide-course-template-library',
})

const COURSE_CHECK_SESSION_KEY = 'releaseGuides:courseTemplateLibrary:hasNoCourses'

// This file is reached from the boot path, so the API client and the flag gate load only when the check runs.
const loadAhafilesApi = () => import('@/api/ahafiles').then((module) => module.default)
const loadFlagGate = () => import('@/services/flagGate')

const listOwnCourseFilesFlagged = () => loadFlagGate().then(({ runFlagged }) => runFlagged(
  COURSE_TEMPLATE_LIBRARY_GUIDE_FLAG,
  () => loadAhafilesApi().then((AhafilesApi) => AhafilesApi.listOwnCourseFiles({ limit: 5 })),
  undefined,
  { featureName: 'course-template-library-guide' },
))

let pendingCourseCheck = null

/** Null (unknown) unless the listing came back; a row trashed through its content marker is not a course. */
export const hasNoLiveCourses = (courseFiles) => (
  Array.isArray(courseFiles) ? courseFiles.every((file) => !!file?.content?.deleted_at) : null
)

const readSessionAnswer = (userId) => {
  try {
    const stored = JSON.parse(sessionStorage.getItem(COURSE_CHECK_SESSION_KEY) || 'null')
    return stored && stored.userId === String(userId) ? stored.hasNoCourses : null
  } catch (e) {
    return null
  }
}

const writeSessionAnswer = (userId, hasNoCourses) => {
  try {
    sessionStorage.setItem(COURSE_CHECK_SESSION_KEY, JSON.stringify({ userId: String(userId), hasNoCourses }))
  } catch (e) {
    // sessionStorage unavailable: the listing is simply asked again on the next sidebar mount.
  }
}

// Asked at most once per browser session; a failed request is reported under the flag, then remembered as "has courses".
const checkHasNoCourses = (userId) => {
  const sessionAnswer = readSessionAnswer(userId)
  if (sessionAnswer !== null) return Promise.resolve(sessionAnswer)
  if (!pendingCourseCheck) {
    pendingCourseCheck = listOwnCourseFilesFlagged()
      .then(hasNoLiveCourses)
      .catch(() => null)
      .then((hasNoCourses) => {
        pendingCourseCheck = null
        const answer = hasNoCourses === true
        writeSessionAnswer(userId, answer)
        return answer
      })
  }
  return pendingCourseCheck
}

/**
 * The course template library is reachable only from an empty Courses subtab, so the guide is for accounts
 * past their first sessions that still have no course. `checkHostingHistory` is the registry's shared gate;
 * the guide's own flag is already checked by the registry before this runs.
 */
export const isInCourseTemplateLibraryAudience = async (store, checkHostingHistory) => {
  const userId = store.state.currentUser?.id
  if (!userId || !(await checkHostingHistory())) return false
  return checkHasNoCourses(userId)
}
